/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description bannerAddTypeUsingPost参数
 * @property `type` banner类别：1：文章、2：问题
 */
export interface ParamsbannerAddTypeUsingPost {
  // pathParams
  /**
   * banner类别：1：文章、2：问题
   */
  type: number;
}
/**
 * list
 */
export type ParamsBodybannerAddTypeUsingPost = Array<models.BannerVO>;
/**
 * @description bannerDeleteTypeUsingDelete参数
 * @property `type` banner类别：1：文章、2：问题
 * @property `[ids]` 被删除bannerId（多个逗号分割)
 */
export interface ParamsbannerDeleteTypeUsingDelete {
  // pathParams
  /**
   * banner类别：1：文章、2：问题
   */
  type: number;
  // queryParams
  /**
   * 被删除bannerId（多个逗号分割)
   */
  ids?: string;
}
/**
 * @description bannerEditTypeUsingPost参数
 * @property `type` banner类别：1：文章、2：问题
 */
export interface ParamsbannerEditTypeUsingPost {
  // pathParams
  /**
   * banner类别：1：文章、2：问题
   */
  type: number;
}
/**
 * bannerVO
 */
export type ParamsBodybannerEditTypeUsingPost = models.BannerVO;
/**
 * @description bannerInitUsingGet参数
 * @property `[type]` type
 */
export interface ParamsbannerInitUsingGet {
  // queryParams
  /**
   * type
   */
  type?: number;
}
/**
 * @description bannerTypeIdUsingGet参数
 * @property `id` bannerId
 * @property `type` banner类别：1：文章、2：问题
 */
export interface ParamsbannerTypeIdUsingGet {
  // pathParams
  /**
   * bannerId
   */
  id: number;
  /**
   * banner类别：1：文章、2：问题
   */
  type: number;
}
export class BannerApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   *
   * @summary 添加banner文章(支持批量)
   * @param params ParamsbannerAddTypeUsingPost
   * @param data: ParamsBodybannerAddTypeUsingPost// list
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public bannerAddTypeUsingPost = (
    params: ParamsbannerAddTypeUsingPost,
    data: ParamsBodybannerAddTypeUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/banner/add/{type}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.type, 'type');
    p.data = data;
    ajax.check(data, 'body.list');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 删除banner(支持批量)
   * @param params ParamsbannerDeleteTypeUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public bannerDeleteTypeUsingDelete = (
    params: ParamsbannerDeleteTypeUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/banner/delete/{type}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('ids' in params) p.query.ids = params.ids;
    ajax.check(params.type, 'type');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 编辑某个banner
   * @param params ParamsbannerEditTypeUsingPost
   * @param data: ParamsBodybannerEditTypeUsingPost// bannerVO
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public bannerEditTypeUsingPost = (
    params: ParamsbannerEditTypeUsingPost,
    data: ParamsBodybannerEditTypeUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/banner/edit/{type}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.type, 'type');
    p.data = data;
    ajax.check(data, 'body.bannerVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary getBannerList
   * @param params ParamsbannerInitUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListBannerVO
   */
  public bannerInitUsingGet = (
    params: ParamsbannerInitUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListBannerVO> => {
    const path = '/api/banner/init';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('type' in params) p.query.type = params.type;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查找某一个banner
   * @param params ParamsbannerTypeIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultBannerVO
   */
  public bannerTypeIdUsingGet = (
    params: ParamsbannerTypeIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultBannerVO> => {
    const path = '/api/banner/{type}/{id}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.id, 'id');
    ajax.check(params.type, 'type');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new BannerApi();
